import Decimal from 'decimal.js';
import { Maths } from 'helpers/maths';

export const convertPercentageFromDecimalToPlain = decimalPercentage => {
  return Maths.multiplyRound(decimalPercentage, 100, 2, Decimal.ROUND_UP);
};
export default convertPercentageFromDecimalToPlain;
